import React, { useState } from 'react';
import { ProQaMetadataStore } from '../store/pro-qa-metada-store';

const ProQaMetadataContext = React.createContext<ProQaMetadataStore | undefined>(undefined);

export function ProQaMetadataProvider({ children }: { children: React.ReactNode }) {
    const [store] = useState(() => new ProQaMetadataStore());

    return (
        <ProQaMetadataContext.Provider value={store}>
            {children}
        </ProQaMetadataContext.Provider>
    );
}

export function useProQaMetadataStore(): ProQaMetadataStore {
    const store = React.useContext(ProQaMetadataContext);

    if (!store) {
        throw new Error('ProQaMetadataStore is not provided');
    }

    return store;
}
